/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Access state of an organization's license (NONE = no license or an inactive one).
 * @export
 */
export const LicenseStatus = {
    Active: 'active',
    Grace: 'grace',
    Expired: 'expired',
    None: 'none'
} as const;
export type LicenseStatus = typeof LicenseStatus[keyof typeof LicenseStatus];


export function instanceOfLicenseStatus(value: any): boolean {
    for (const key in LicenseStatus) {
        if (Object.prototype.hasOwnProperty.call(LicenseStatus, key)) {
            if (LicenseStatus[key as keyof typeof LicenseStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LicenseStatusFromJSON(json: any): LicenseStatus {
    return LicenseStatusFromJSONTyped(json, false);
}

export function LicenseStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): LicenseStatus {
    return json as LicenseStatus;
}

export function LicenseStatusToJSON(value?: LicenseStatus | null): any {
    return value as any;
}

export function LicenseStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): LicenseStatus {
    return value as LicenseStatus;
}

